/*
* Copyright (C) Regione Lombardia
*/
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ViewerService {

    constructor(
        private httpClient: HttpClient,
    ) { }

    public getUrlViewer(): Observable<string> {
        return this.httpClient.get<string>(`${environment.urlApi}/public/viewer`);
    }

    public getUrlViewerOpera(idOpera: number, codIstat: string, idTipologiaOpera: number): Observable<string> {
        return this.httpClient.get<string>(`${environment.urlApi}/private/viewer/opera?idOpera=${idOpera}&codIstat=${codIstat}&idTipologiaOpera=${idTipologiaOpera}`);
    }

}
